import moment from 'moment'
import Vue from 'vue'

Vue.filter('poids', function(value: number) {
  if (value || value === 0) {            
      if (value >= 1000) {
        return (Math.round(value / 1000 * 100 ) / (100)) + ' kg'
      }
      return (Math.round(value * 100) / 100) + ' g'
  }
})